var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$store.getters.getUserHasFeature('calendar'))?_c('calendar'):_c('div',{staticClass:"wrapper pt-3 pb-1"},[_c('f-alert',{staticClass:"my-2",attrs:{"visible":"","theme":"inactive"}},[_c('span',[_vm._v(" "+_vm._s(_vm.$t('user.currentPackageDoesNotIncludeAccessToSection'))+" ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }